import React from 'react';
import {ConfigProvider} from "antd";

function CustomPrimary({color, children}) {
	if (!color){
		return children
	}
	return (<ConfigProvider theme={{
		token: {
			colorPrimary: color,
		},
	}}>{children}</ConfigProvider>)
}

export default CustomPrimary;